export default __webpack_public_path__ + "static/media/crying-89.2c16e728.webp";